import { useState } from 'react';

import { IPaginationPagesLimit } from 'shared/types';

export const usePagination = () => {
  const [{ page, limit }, setCurrentPage] = useState<IPaginationPagesLimit>({
    page: 1,
    limit: 10,
  });

  return { page, limit, setCurrentPage };
};
